'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var toggleDrawer = function toggleDrawer() {
  return {
    eventCategory: 'User',
    eventAction: 'Toggled Drawer'
  };
};

exports.default = toggleDrawer;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/ga-event-templates/lib/toggleDrawer.js
// module id = 1419
// module chunks = 1